// Date format constants - IMPORTANT: date-fns and moment.js use different format tokens!
// date-fns: yyyy = year, MM = month, dd = day
// moment:   YYYY = year, MM = month, DD = day
// Using the wrong format will produce malformed dates (e.g., "2026-01-Th" instead of "2026-01-05")
export const DATE_FORMAT = "yyyy-MM-dd HH:mm:ss"; // For date-fns
export const DATE_FORMAT_MOMENT = "YYYY-MM-DD HH:mm:ss"; // For moment.js
export const PLANS_FEATURES = {
  "sked-professional": ["approvals"],
  "sked-enterprise": ["approvals"],
  "sked-custom": ["approvals"],
  "sked-essentials": ["approvals"],
};
export const PLANS = Object.keys(PLANS_FEATURES);
